import { TrackingRecoSectionContext } from '@aboutyou/legacy-tracking-sdk'
import { disableSecondLoveBadge } from 'helpers/products'
import { RecoSliderSectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import React, { FC } from 'react'
import ProductTileConnected from 'sharedComponents/ProductTileConnected/ProductTileConnected'
import Product from 'store/entities/Product/Product.store'
import styled, { css } from 'styled-components'
import RowSection from 'uiComponents/atoms/Sections/RowSection'
import HorizontalSlider, {
  SliderControlProps,
} from 'uiComponents/molecules/Slider/HorizontalSlider'

const DividerSection = styled(RowSection)<{ constrained?: boolean }>`
  ${({ constrained }) =>
    constrained
      ? null
      : css`
          margin-bottom: 120px;
        `};
`

interface IProductRecoSliderProps {
  products: Product[] | null
  recoType: TrackingRecoSectionContext['recoType']
  slideCounts: {
    slideCount: number
    slideCountMedium: number
    slideCountLarge: number
  }
  dataTestId: string
  title?: React.ReactNode
  pullStart?: boolean
  pullEnd?: boolean
  constrained?: boolean
  trackingRecoTitle?: string
  maxNumProducts?: number
  SlideControlComponent?: React.ComponentType<SliderControlProps>
}

const ProductRecoSlider: FC<IProductRecoSliderProps> = ({
  products,
  slideCounts,
  dataTestId,
  constrained,
  pullStart,
  pullEnd,
  title,
  maxNumProducts = 8,
  recoType,
  SlideControlComponent,
}) => {
  if (!products || !products.length) {
    return null
  }

  return (
    <DividerSection
      data-testid={dataTestId}
      pullStart={pullStart}
      pullEnd={pullEnd}
      constrained={constrained}
    >
      <HorizontalSlider
        dataTestId="HorizontalSlider"
        title={title}
        as="div"
        hideSideButtons
        SlideControlComponent={SlideControlComponent}
        constrained={constrained}
        showsProductTiles
        {...slideCounts}
      >
        {products.slice(0, maxNumProducts).map(({ id }) => (
          <ProductTileConnected
            key={id}
            productId={id}
            productModifiers={[disableSecondLoveBadge]}
            recoType={recoType}
          />
        ))}
      </HorizontalSlider>
    </DividerSection>
  )
}

const TrackedProductRecoSlider: FC<IProductRecoSliderProps> = props => (
  <RecoSliderSectionTrackingContextProvider
    headline={props.trackingRecoTitle}
    recoType={props.recoType}
  >
    <ProductRecoSlider {...props} />
  </RecoSliderSectionTrackingContextProvider>
)

export default TrackedProductRecoSlider
